define('C3.ShoppingExtensions.IncomingEquipment.MainView'
, 	[
        'SCView',
         'c3_shoppingextensions_incomingequipment.tpl'
   // ,    'SCCollectionView'
    
	],
function (
        SCViewModule,
         c3_shoppingextensions_incomingequipment_tpl
     //,   SCCollectionViewModule
   
){
	'use strict';

	 var SCView = SCViewModule.SCView;

	  function IncomingEquipmentMainView (options) {
        SCView.call(this, options.collection);

        this.template = c3_shoppingextensions_incomingequipment_tpl;
        this.options = options;
        this.application = options.application;
        this.configuration = this.application.Configuration;

    }

    IncomingEquipmentMainView.prototype = Object.create(SCView.prototype);
    IncomingEquipmentMainView.prototype.constructor = IncomingEquipmentMainView;


    IncomingEquipmentMainView.prototype.render = function () { 
        var self = this;
        SCView.prototype.render.call(self);
    }

    IncomingEquipmentMainView.prototype.getContext = function () {


        return {

        }
    }

    return IncomingEquipmentMainView
});
